export const SAN_DIEGO_SHORT_TERM_RENTALS_BANNER_STRINGS = {
  link: 'https://belonghome.com/blog/san-diego-short-term-rentals',
  title_line_one: 'San Diego Introduces New Rules and',
  title_line_two_first_phrase: 'Caps For',
  title_line_two_bold_phrase: ' Short-Term',
  title_line_two_last_phrase: '\u00a0Rentals',
  body: 'San Diego City Council has recently approved a short-term rental\u00a0ordinance...',
  'image.alt': 'Short-Term Rentals Image',
  read_more: 'READ MORE',
};
